// API related actions
export const CREATING_SALES_AND_BUDGETS = '@@toyota/CREATING_SALES_AND_BUDGETS';
export const CREATED_SALES_AND_BUDGETS = '@@toyota/CREATED_SALES_AND_BUDGETS';
export const CREATED_SALES_AND_BUDGETS_FAILED = '@@toyota/CREATED_SALES_AND_BUDGETS_FAILED';


// complementary actions
export const CLEAR_SALES_AND_BUDGETS_DATA = '@@toyota/CLEAR_SALES_AND_BUDGETS_DATA';
export const SAVE_SALES_AND_BUDGETS_DATA_FROM_EXCEL = '@@toyota/SAVE_SALES_AND_BUDGETS_DATA_FROM_EXCEL';
export const CHANGE_SALES_AND_BUDGETS_LIST_PAGE = '@@toyota/CHANGE_SALES_AND_BUDGETS_LIST_PAGE';
export const CHANGE_SALES_AND_BUDGETS_LIST_PAGE_SIZE = '@@toyota/CHANGE_SALES_AND_BUDGETS_LIST_PAGE_SIZE';
